import React from "react";
import { Box } from "@mui/material";

const raleway = { fontFamily: "'Geist', sans-serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };
const instrumentSerif = { fontFamily: "'Instrument Serif', serif" };

const STEPS = [
  {
    title: "Choose Loan",
    description:
      "Select the loan option that best fits your personal or business needs.",
  },
  {
    title: "Submit your Details",
    description:
      "Fill in your information and upload the required documents securely.",
  },
  {
    title: "Review and Approval",
    description:
      "Our team reviews your application and contacts you with the next update.",
  },
  {
    title: "Receive Funds",
    description: "Once approved, funds are disbursed to your account.",
  },
];

const LoanSteps = () => {
  return (
    <Box
      sx={{
        background: "transparent",
        boxSizing: "border-box",
        padding: "clamp(48px, 6.94vw, 100px) clamp(20px, 5.56vw, 80px)",
      }}
    >
      <div style={{ maxWidth: "1440px", margin: "0 auto" }}>
        <Box
          sx={{
            background: "#132A22",
            borderRadius: "16px",
            padding: "clamp(40px, 5.56vw, 80px) clamp(20px, 4.17vw, 60px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "clamp(32px, 2.78vw, 40px)",
          }}
        >
          <div
            className="flex flex-col items-center"
            style={{ gap: "clamp(12px, 1.39vw, 20px)" }}
          >
            {/* Label */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#86C7A8",
                  flexShrink: 0,
                  display: "inline-block",
                }}
              />
              <span
                style={{
                  ...geistMono,
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: 1,
                  letterSpacing: "0.1em",
                  color: "#86C7A8",
                  textTransform: "uppercase",
                }}
              >
                Quick Onboarding
              </span>
            </div>

            <h2
              className="text-center"
              style={{
                ...instrumentSerif,
                fontWeight: 400,
                fontSize: "clamp(28px, 4.17vw, 60px)",
                lineHeight: 1.1,
                letterSpacing: "-0.01em",
                color: "#FFFFFF",
                margin: 0,
              }}
            >
              Apply for{" "}
              <span
                style={{
                  ...instrumentSerif,
                  fontStyle: "italic",
                  color: "#86C7A8",
                }}
              >
                ZForHer
              </span>{" "}
              loan in these few simple steps
            </h2>
          </div>

          <div
            className="w-full flex sm:flex-col"
            style={{
              gap: "clamp(24px, 5.9vw, 85px)",
              alignItems: "flex-start",
              justifyContent: "center",
              maxWidth: "1187px",
            }}
          >
            {STEPS.map((step, i) => (
              <div
                key={step.title}
                className="flex flex-col items-center sm:flex-row sm:items-start sm:w-full"
                style={{
                  flex: "1 1 0",
                  minWidth: 0,
                  gap: "16px",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "8px",
                    background: "rgba(255, 255, 255, 0.06)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 700,
                      fontSize: "20px",
                      color: "rgba(238, 238, 238, 0.32)",
                      lineHeight: 1,
                    }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                {i < STEPS.length - 1 && (
                  <>
                    <div
                      className="flex sm:hidden"
                      style={{
                        position: "absolute",
                        top: "20px",
                        left: "calc(50% + 70px)",
                        width: "calc(100% + clamp(24px, 5.9vw, 85px) - 140px)",
                        height: "4px",
                        alignItems: "center",
                        gap: "6px",
                        pointerEvents: "none",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          height: "0",
                          backgroundImage:
                            "linear-gradient(to right, rgba(102, 166, 129, 0.55) 50%, transparent 50%)",
                          backgroundSize: "12px 2px",
                          backgroundRepeat: "repeat-x",
                          backgroundPosition: "left center",
                          borderTop: "2px solid transparent",
                        }}
                      />
                      <div
                        style={{
                          width: "6px",
                          height: "6px",
                          background: "rgba(102, 166, 129, 0.8)",
                          transform: "rotate(45deg)",
                          flexShrink: 0,
                        }}
                      />
                    </div>
                    <div
                      className="hidden sm:flex"
                      style={{
                        position: "absolute",
                        top: "52px",
                        left: "20px",
                        bottom: "calc(-1 * clamp(24px, 5.9vw, 85px))",
                        width: "4px",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "6px",
                        pointerEvents: "none",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          width: "0",
                          backgroundImage:
                            "linear-gradient(to bottom, rgba(102, 166, 129, 0.55) 50%, transparent 50%)",
                          backgroundSize: "2px 12px",
                          backgroundRepeat: "repeat-y",
                          backgroundPosition: "center top",
                          borderLeft: "2px solid transparent",
                        }}
                      />
                      <div
                        style={{
                          width: "6px",
                          height: "6px",
                          background: "rgba(102, 166, 129, 0.8)",
                          transform: "rotate(45deg)",
                          flexShrink: 0,
                        }}
                      />
                    </div>
                  </>
                )}
                <div
                  className="flex flex-col items-center text-center sm:items-start sm:text-left"
                  style={{ gap: "8px" }}
                >
                  <p
                    style={{
                      ...raleway,
                      fontWeight: 600,
                      fontSize: "clamp(16px, 1.39vw, 20px)",
                      color: "#FFFFFF",
                      margin: 0,
                    }}
                  >
                    {step.title}
                  </p>
                  <p
                    style={{
                      ...raleway,
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "26px",
                      color: "#DEDEDE",
                      margin: 0,
                      maxWidth: "246px",
                    }}
                  >
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Box>
      </div>
    </Box>
  );
};

export default LoanSteps;
